import { render, staticRenderFns } from "./HostingWidget.vue?vue&type=template&id=baea25f8&"
import script from "./HostingWidget.vue?vue&type=script&lang=js&"
export * from "./HostingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports